var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center viewStyle p-5",style:({'background':_vm.data.background})},[_c('img',{attrs:{"src":require(`@/assets/images/home-assets/${_vm.data.imagesrc}`),"alt":""}}),_c('p',{staticClass:"mt-5",staticStyle:{"color":"white"}},[_vm._v(" "+_vm._s(_vm.data.discription)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }